import React from 'react'

const ArrowUpFull = ({ fill = '#0D8443' }) => (
  <svg
    width="10"
    height="11"
    viewBox="0 0 10 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.99499 0.5L0.75 4.76131L2.16166 6.18844L3.94376 4.3995V10.5H5.94611V4.299L7.82833 6.18844L9.25 4.76131L4.99499 0.5Z"
      fill={fill}
    />
  </svg>
)

export default ArrowUpFull
